import { render, staticRenderFns } from "./TableColumnBadges.vue?vue&type=template&id=9775e1fe"
import script from "./TableColumnBadges.vue?vue&type=script&lang=js"
export * from "./TableColumnBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports